import { Handler, IframeSelectionPayload } from "../common/types";
import { logger } from "../services/logger";
import { MsgBusActions } from "../common/events";
import {
  getPopularBetBuilderBetListName,
  getPopularBetBuilderEventCategory,
} from "../common/utils";
import { track } from "@sb/analytics";

export const editSelection: Handler<IframeSelectionPayload> = async (
  payload,
  { msgBus, gtpService, stateMngr },
) => {
  logger.log(`[From Iframe]: Edit selections: `, payload);
  track({
    EventName: "popular_BetBuilder_edit",
    EventAction: "Edit Bets for Betslip",
    EventLabel: payload.analytics.accaName,
    EventCategory: getPopularBetBuilderEventCategory(),
    BetListName: [getPopularBetBuilderBetListName()],
  });

  try {
    const gtpRes = await gtpService.getBetSlipMapping(payload);
    const { byoSelectionDetails } = stateMngr.handleAddToBetslip(
      payload,
      gtpRes.mappings,
    );
    const response = {
      eventId: payload.legacyEventId,
      data: { byoSelectionDetails },
    };
    msgBus.publish(MsgBusActions.EDIT, response);
    logger.log(`[To MsgBus]: ${MsgBusActions.ADD_TO_SLIP_BB}: `, response);
  } catch (err) {
    console.error(err);
  }
};
